import styled from 'styled-components'

import { Icon } from 'src/components'

export const ChevronIcon = styled(Icon)<{ $isActive: boolean }>`
  background: none;
  transform: rotate(${(props) => (props.$isActive ? '180deg' : '360deg')});
  transition: all ease-out 0.2s;
  color: currentColor;
`

ChevronIcon.displayName = 'ChevronIcon'
